import {TR} from './TR';
export class TypeTableCar1 {

	public tr: TR[];

	constructor() { 
		 		this.tr = [];
 
	}
}
